export default function ApplicationLogo(props) {

    const { company } = props;
    const logo = company?.logo ? company.logo : '/images/WHL-Logo.png';
    const logoAlt = company?.name ? company.name : 'WHL';

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>
            <img src={logo} height={70} alt={logoAlt} />
            <div style={{ width: '1px', height: '50px', backgroundColor: '#dee2e6' }}></div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                <span style={{ fontSize: '9px', color: '#888888', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '4px' }}>
                    Powered By
                </span>
                <img src="/images/VehicleVueLogo.png" height={60} alt="VehicleVue Logo" />
            </div>
        </div>
    );
}
